/**
 * WordPress dependencies.
 */
import { render, useState } from '@wordpress/element';
import domReady from '@wordpress/dom-ready';
import { __ } from '@wordpress/i18n';
import { Modal, Icon } from '@wordpress/components';
import { applyFilters, addFilter } from '@wordpress/hooks';

import { GridView as icon } from '../../components/Icons';

const { plugin_directory_url: pluginDirectoryUrl, gutenify_version: gutenifyVersion, site_url: siteUrl } = window._gutenify_vars;

const AppCompose = () => {
	const [ isKitModalOpen, setKitModelState ] = useState( false );
	const [ isTemplateModalOpen, setTemplateModelState ] = useState( false );
	const [ subscriptionEmail, setSubscriptionEmail ] = useState( '' );

	const { is_pro_activated: isProActive } = window._gutenify_vars;
	console.log( ! isProActive );
	return <>
		<div className="gutneify--getting-started--wrapper">
			<div id="gutenify-admin-about-page">
				<div className="gutenify-about-container  gutenify-admin-card gutenify-admin-card-header admin-grid-2">
					<div className="gutenify-header-left admin-col">
						<h2>{ __( 'Gutenify' ) } &nbsp;-&nbsp;v{ gutenifyVersion } </h2>
						<p>{ __( 'Gutenberg Fullsite Editing Template Kits – Advanced Blocks' ) }</p>
					</div>
					<div className="gutenify-card-header-button-group">
							<a href={ `${ siteUrl }/wp-admin/admin.php?page=gutenify-template-kits` } className="gutenify-admin-button" rel="noreferrer">
								<i className="fa fa-paint-brush"></i> { __( 'Template Kits' ) }
							</a>
							{ !! isProActive && <a href="https://gutenify.com/documentations/" className="gutenify-admin-button premium-button" target="_blank" rel="noreferrer">
								<i className="fa fa-book"></i> { __( 'Documentations' ) }
							</a> }

							{ ! isProActive && <a href="https://gutenify.com/pricing/" className="gutenify-admin-button premium-button" target="_blank" rel="noreferrer">
								<i className="fa fa-fire"></i> { __( 'PRO' ) }
							</a> }

						</div>
				</div>
				<div className="gutenify-about-container subscribe-panel admin-grid-2">
					<div className="admin-col">
						<div className="gutentor-get-started-content">
							<h3>Gutenify Template Kits</h3>
							<p>Gutenify has pre-built template kits for your site which will give your website a base structure.</p>

							<ul>
								<li> <i className="fa fa-book" aria-hidden="true"></i> <a href="https://gutenify.com/documentations/template-kits/" target="_blank" rel="noreferrer">Learn about Template Kits</a></li>
								<li> <i className="fa fa-search" aria-hidden="true"></i> <a href={ `${ siteUrl }/wp-admin/admin.php?page=gutenify-template-kits` } rel="noreferrer">Browse Template Kits</a></li>
							</ul>
							<h4>How to import Template Kits?</h4>
							<p><a href="https://gutenify.com/documentations/template-kits/" target="_blank" rel="noreferrer">Click here</a> or Watch our quick video <i className="fa fa-arrow-right" aria-hidden="true"></i></p>
						</div>
					</div>
					<div className="admin-col">
						<button type="button" className="btn btn-play play-btn" onClick={ () => setKitModelState( true ) }>
							<picture>
								<img className="play-button" src={ `${ pluginDirectoryUrl }assets/images/admin/play-icon.png` } alt="dashboard-alt" />
							</picture>
						</button>
						<img src={ `${ pluginDirectoryUrl }assets/images/admin/gutenify-template-kits.png` } alt="dashboard-alt" />
						{ isKitModalOpen && (
							<Modal title={ __( 'How to import Template Kit?' ) } onRequestClose={ () => setKitModelState( false ) } className="gutneify--getting-started--video-wrapper">
								<video width="320" height="240" controls>
									<source src="https://gutenify-com.s3.amazonaws.com/wp-content/uploads/2022/03/16161807/Gutenify-template-kits-1.mp4" type="video/mp4" />
									Your browser does not support the video tag.
								</video>
							</Modal>
						) }
					</div>
				</div>
				<div className="gutenify-about-container subscribe-panel">
					<div className="admin-grid-2">
						<div className="admin-col">
							<button type="button" className="btn btn-play play-btn" onClick={ () => setTemplateModelState( true ) }>
								<picture>
									<img className="play-button" src={ `${ pluginDirectoryUrl }assets/images/admin/play-icon.png` } alt="dashboard-alt" />
								</picture>
							</button>
							<img src={ `${ pluginDirectoryUrl }assets/images/admin/gutenify-template.png` } alt="dashboard-alt" />
							{ isTemplateModalOpen && (
								<Modal title={ __( 'How to import Templates (Patterns)?' ) } onRequestClose={ () => setTemplateModelState( false ) }className="gutneify--getting-started--video-wrapper">
									<video width="320" height="240" controls>
										<source src="https://gutenify-com.s3.amazonaws.com/wp-content/uploads/2022/03/16155705/template-add-gutenify.mp4" type="video/mp4" />
										Your browser does not support the video tag.
									</video>
								</Modal>
							) }
						</div>
						<div className="admin-col">
							<div className="gutenify-get-started-content">
								<h3>Import Templates (Patterns)</h3>
								<p>From Edit screen of page/post, you can easily import Beautiful Templates</p>
								<ul>
									<li> <i className="fa fa-book" aria-hidden="true"></i> <a href="https://gutenify.com/documentations/what-are-templates-how-do-we-add-templates-in-our-page-posts/" target="_blank" rel="noreferrer">Learn about Templates</a></li>
									<li> <i className="fa fa-pencil" aria-hidden="true"></i> <a href={ `${ siteUrl }/wp-admin/post-new.php?post_type=page` } rel="noreferrer">Create page to add template</a></li>
								</ul>
								<h4>How to import Templates?</h4>
								<p><i className="fa fa-arrow-left" aria-hidden="true"></i> Watch our quick video or <a href="https://gutenify.com/documentations/what-are-templates-how-do-we-add-templates-in-our-page-posts/" target="_blank" rel="noreferrer">Click here</a>  </p>
							</div>
						</div>
					</div>
				</div>
				<div className="gutenify-about-container subscribe-panel">
					<h3>To add fresh block follow below steps</h3>
					<ul>
						<li><img src={ `${ pluginDirectoryUrl }assets/images/admin/check.png` } alt="dashboard-alt" />  At the top left corner of the page/post edit Screen, click on Sign</li>
						<li><img src={ `${ pluginDirectoryUrl }assets/images/admin/check.png` } alt="dashboard-alt" />  Type Block name in search bar, if you already know the block name.</li>
						<li><img src={ `${ pluginDirectoryUrl }assets/images/admin/check.png` } alt="dashboard-alt" />  OR Scroll down and navigate to Gutenify section and Add New Block.</li>
					</ul>
				</div>
				<div className="feature-list">
					<div className="gutenify-about-container gutenify-about-content">
						<div className="gutenify-admin-card features">
							<h4 className="gutenify-admin-card-title is-medium is-sub">
								gutenify Core Features </h4>
							<ul className="gutenify-options-features">
								<li><img src={ `${ pluginDirectoryUrl }assets/images/admin/check.png` } alt="dashboard-alt" /> Global page settings(typography, color,
									...)</li>
								<li><img src={ `${ pluginDirectoryUrl }assets/images/admin/check.png` } alt="dashboard-alt" /> Template Kits</li>
								<li><img src={ `${ pluginDirectoryUrl }assets/images/admin/check.png` } alt="dashboard-alt" /> Predefined sections</li>
								<li><img src={ `${ pluginDirectoryUrl }assets/images/admin/check.png` } alt="dashboard-alt" /> Fully Responsive</li>
								<li><img src={ `${ pluginDirectoryUrl }assets/images/admin/check.png` } alt="dashboard-alt" /> Highly customizable row columns</li>
								<li><img src={ `${ pluginDirectoryUrl }assets/images/admin/check.png` } alt="dashboard-alt" /> Color Options</li>
								<li><img src={ `${ pluginDirectoryUrl }assets/images/admin/check.png` } alt="dashboard-alt" /> Device specific responsive controls</li>
								<li><img src={ `${ pluginDirectoryUrl }assets/images/admin/check.png` } alt="dashboard-alt" /> Google fonts</li>
								<li><img src={ `${ pluginDirectoryUrl }assets/images/admin/check.png` } alt="dashboard-alt" /> Classic &amp; gradient color and
									background</li>
								<li><img src={ `${ pluginDirectoryUrl }assets/images/admin/check.png` } alt="dashboard-alt" /> Box-shadow</li>
								<li><img src={ `${ pluginDirectoryUrl }assets/images/admin/check.png` } alt="dashboard-alt" /> Border</li>
								<li><img src={ `${ pluginDirectoryUrl }assets/images/admin/check.png` } alt="dashboard-alt" /> Advanced Typography</li>
								<li><img src={ `${ pluginDirectoryUrl }assets/images/admin/check.png` } alt="dashboard-alt" /> Font Awesome 4 icon picker</li>
								<li><img src={ `${ pluginDirectoryUrl }assets/images/admin/check.png` } alt="dashboard-alt" /> & More...</li>
							</ul>

						</div>
					</div>
					<div className="gutenify-about-side">
						<div className="gutenify-admin-card member">
							<span><i className="fa fa-star" aria-hidden="true"></i> <i className="fa fa-star" aria-hidden="true"></i> <i className="fa fa-star" aria-hidden="true"></i> <i className="fa fa-star" aria-hidden="true"></i> <i className="fa fa-star" aria-hidden="true"></i></span>
							<h3 className="gutenify-admin-card-title is-small">
								Love our product?
							</h3>
							<h4 className="gutenify-admin-card-title is-small">
								Motivate us by giving 5 star on our profile.
							</h4>
							<a href="https://wordpress.org/support/plugin/gutenify/reviews/?filter=5"
								className="gutenify-admin-button large gutenify-block is-default" target="__blank">
								Rate Us
							</a>
						</div>
						<div className="gutenify-admin-card cart-two">
							<h3 className="gutenify-admin-card-title is-small">
								Still have question? Ask Us, now! </h3>
							<p>We are always ready with all fix issues you stuck to ensure smoothly works with
								gutenify</p>
							<a href="https://gutenify.com/contact/"
								className="gutenify-admin-button primary large gutenify-block">Get Support</a>
						</div>
					</div>
				</div>
				{ /* <div className="gutenify-about-container gutenify-admin-card gutenify-admin-card-header">
					<div className="admin-col">
						<h3>Subscribe to Get The Latest News on Gutenify</h3>
						<p>We will inform you about the updates, upcoming new features, and other infos related
							to Gutenify plugin.</p>
						<form id="subcription-email" onSubmit={ ( e ) => {
							e.preventDefault();
							apiFetch( {
								url: 'https://gutenify.com/wp-json/gutenify-internal/v1/subscribe-email',
								method: 'POST',
								data: { email: subscriptionEmail },
							} ).then( ( res ) => {
								console.log( res );
							} );
							return false;
						} }>
							<input type="text" placeholder="Your Email Address" onChange={ ( val ) => {
								setSubscriptionEmail( val.target.value );
							} } value={ subscriptionEmail } required />
							<button type="submit" className="wp-block-search__button   has-icon"
								aria-label="Search"> Subscribe
							</button>
						</form>
						<span className="note">Join to be one of early users to subscribed.</span>
					</div>

				</div> */ }

			</div>
			<div className="gutenify-card-header-button-group">
				<a href={ `${ siteUrl }/wp-admin/admin.php?page=gutenify-template-kits` } className="gutenify-admin-button primary large" rel="noreferrer"><i className="fa fa-paint-brush"></i> Template Kits</a>
				{ !! isProActive && <a href="https://gutenify.com/documentations/" className="gutenify-admin-button premium-button" target="_blank" rel="noreferrer">
					<i className="fa fa-book"></i> { __( 'Documentations' ) }
				</a> }

				{ ! isProActive && <a href="https://gutenify.com/pricing/" className="gutenify-admin-button premium-button" target="_blank" rel="noreferrer">
					<i className="fa fa-fire"></i> { __( 'PRO' ) }
				</a> }
				{ /* <a href="https://gutenify.com/support/" className="gutenify-admin-button premium-button" target="_blank" rel="noreferrer">
					Support
				</a> */ }
			</div>
		</div>
	</>;
};
domReady( function() {
	const appID = 'gutenify-getting-started-app';
	if ( 'undefined' !== typeof document.getElementById( appID ) && null !== document.getElementById( appID ) ) {
		render( <AppCompose />, document.getElementById( appID ) );
	}
} );
